import { useMemo } from 'react';

import { useChannels } from '../../../../hooks/queries';
import { useTranslation } from '../../../../hooks/useTranslation';
import { doesChannelMatchSearch } from './doesChannelMatchSearch';

type UseChannelOptionsProps = {
  search: string;
};

export const useChannelOptions = ({ search }: UseChannelOptionsProps) => {
  const { t } = useTranslation();
  const { channels, didError, isLoading } = useChannels();

  const options = useMemo(
    () =>
      channels
        .filter(({ id, name, messageMedium, channelType }) =>
          doesChannelMatchSearch(id, name, messageMedium, channelType, search),
        )
        .map((channel) => ({
          title: channel.name,
          subtitle: `${t('v2.conditionBuilder.channelSubtitle', { id: channel.id })} • ${channel.messageMedium} • ${channel.channelType}`,
          value: channel.id.toString(),
        })),
    [channels, t, search],
  );

  return { options, didError, isLoading };
};
